import Link from 'next/link';
import {INotFoundDictionary} from '@/dictionaries/utils/notFound/types';

export type ErrorType = 'not-found' | 'error' | 'forbidden';

type Props = {
  lang: string;
  dict: INotFoundDictionary;
  errorType?: ErrorType;
};

export default function ErrorPage({lang, dict, errorType}: Props) {
  const homePageLink = lang === 'en' ? '/' : `/${lang}`;

  const forbiddenDict = dict.forbidden;
  const pageNotFoundDict = dict.pageNotFound;
  const errorDict = dict.error;

  const createErrorTitle = () => {
    switch (errorType) {
      case 'forbidden':
        return forbiddenDict.title;
      case 'not-found':
        return pageNotFoundDict.title;
      default:
        return errorDict.title;
    }
  };

  const createErrorDescription = () => {
    switch (errorType) {
      case 'forbidden':
        return forbiddenDict.description;
      case 'not-found':
        return (
          <>
            {pageNotFoundDict.description}
            <Link href={homePageLink}>
              {pageNotFoundDict.linkContent} <b>{pageNotFoundDict.homepage}</b>
            </Link>
            .
          </>
        );
      default:
        return errorDict.description;
    }
  };

  return (
    <div className="min-h-[calc(100vh-100px)] desktop:min-h-[calc(100vh-200px)]">
      <div className="text-center py-[200px]">
        <h1 className="mb-2 text-title font-title">{createErrorTitle()}</h1>
        <p className="mb-4">{createErrorDescription()}</p>
      </div>
    </div>
  );
}
